import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';

const ScribeDeleteModal = ({ isOpen, onClose, onConfirm, consultation, patientName, loading }) => {
  if (!isOpen || !consultation) return null;

  return (
    <div className="modal-overlay">
      <div className="delete-modal">
        <div className="modal-header">
          <h2>Confirm Delete</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p>Are you sure you want to delete this consultation?</p>
          <div className="document-details">
            <div className="detail-row">
              <span className="detail-label">Patient:</span>
              <span className="detail-value">{patientName || consultation.nhsId || 'Unknown'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Created:</span>
              <span className="detail-value">
                {consultation.timestamp ? new Date(consultation.timestamp).toLocaleString() : 'Unknown'}
              </span>
            </div>
          </div>
          <p style={{ marginTop: '15px', color: '#e74c3c', fontSize: '14px', fontWeight: '600' }}>
            This will permanently delete the recording and all generated content.
          </p>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose} disabled={loading}>Cancel</button>
          <button className="delete-confirm-button" onClick={onConfirm} disabled={loading}>
            {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScribeDeleteModal;
